module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門4_9_3.3a7a80db.png";